// @ts-nocheck
import { MetaTags } from "modules/look";
import React from "react";
import "../css/rewards.css";
import RewardSystemOverviewContainer from "../containers/reward-system-overview-container";
import RewardSystemHistoryContainer from "../containers/reward-system-history-container";
import RewardSystemEarnMoreContainer from "../containers/reward-system-earn-more-container";
import RewardSystemRedeemContainer from "../containers/reward-system-redeem-container";

const RewardSystemHomeView = (props) => {
    const { location, rewardPermission } = props;
    const tab = React.useMemo(() => ([
        {
            key: 'overview',
            label: 'Overview',
        },
        {
            key: 'history',
            label: 'History',
        },
        {
            key: 'earn_more',
            label: 'Earn More'
        },
        {
            key: 'redeem',
            label: 'Redeem'
        }
    ]), [])

    const [current_tab, SetCurrentTab] = React.useState(
        {
            key: 'overview',
            label: 'Overview',
        }
    )
    React.useEffect(() => {
        if (location?.search) {
            let search = location.search.replace('?', '')
            if (search === "tip_settings") {
                SetCurrentTab(
                    {
                        key: 'redeem',
                        label: 'Tips Settings',
                    }
                )
            }
            else if (search === "history") {
                SetCurrentTab(
                    {
                        key: 'history',
                        label: 'History',
                    }
                )
            }
        }
    }, [location])

    const content = {
        overview: RewardSystemOverviewContainer,
        history: RewardSystemHistoryContainer,
        earn_more: RewardSystemEarnMoreContainer,
        redeem: RewardSystemRedeemContainer
    }

    const CurrentView = content[current_tab?.key]
    return (
        <div>
            <MetaTags title="Employee reward" description="Employee reward" />
            <div className='reward-card'>
                <div className='reward-tab-view' style={{ background: current_tab?.key === 'overview' ? "#FFFFFF" : "", borderRadius: current_tab?.key === 'overview' ? "0.75em 0.75em 0 0" : "" }}>
                    {
                        tab?.map(tab => (
                            <div className={`reward-tab-normal ${(current_tab?.key === tab?.key || (current_tab?.key?.includes(tab?.key))) ? 'reward-tab-active' : ''}`} onClick={() => SetCurrentTab(tab)} style={{ display: 'flex', flexDirection: "row", justifyContent: 'center', alignItems: 'center', gap: '1em' }}>
                                <h4 className={`reward-tab-label ${(current_tab?.key === tab?.key || (current_tab?.key?.includes(tab?.key))) ? 'reward-tab-active-label' : ''}`} style={{ color: current_tab?.key === tab?.key ? '#4CCB1F' : '#000' }}>{tab?.label}</h4>
                            </div>
                        ))
                    }
                    <div className='border-line'>

                    </div>
                </div>
                <div className='reward-content-container'>

                    {
                        content[current_tab?.key] && (

                            <CurrentView current_tab={current_tab} rewardPermission={rewardPermission} {...props} />
                        )
                    }
                </div>
            </div>
        </div>
    )

}
export default RewardSystemHomeView